/**
 * @file catalog.ts
 * @description API сервис для работы с каталогами в Task Manager приложении, который обеспечивает интерфейс для получения списков каталогов различных типов через REST API. Предоставляет унифицированный метод getList для загрузки данных каталогов с поддержкой фильтрации, пагинации и поиска через POST запросы с передачей параметров в теле запроса и query параметрах.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js']
 * @related-files ['src/features/catalog/catalog.component.tsx', 'src/api/actions.ts']
 */

import { TApiData } from '@src/types';
import { postRequest } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const CatalogService = {
    /**
     * Получает список элементов каталога по имени каталога
     * @param {string} name - Имя каталога для получения списка
     * @param {TApiData} [body] - Тело запроса с параметрами фильтрации и поиска
     * @param {TApiData} [params] - Query параметры для дополнительной настройки запроса
     * @returns {Promise} Промис с данными списка каталога или ошибкой
     */
    getList: async (name: string, body?: TApiData, params?: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postRequest(`list/${name}`, body, params);
    }
};
